<template>
  <div>
    <b-skeleton-table v-if="fetchData" :rows="3" :columns="2" :table-props="{ bordered: true, striped: true }" />

    <b-container class="m-1" v-else>
      <!-- Info text -->
      <b-row v-if="!config_programme">
        <h4>
          All reports are listed below. Select the reports to add them to course file
        </h4>
      </b-row>
      <br />
      <b-row v-if="!config_programme || course_file_allow_add_remove">
        <!-- Show only if course_file_allow_add_remove is false -->
        <b-col v-if="!course_file_allow_add_remove && visibleReports.length < 1" class="text-info">
          All reports are selected
        </b-col>

        <!-- Select All: hide if course_file_allow_add_remove is true -->
        <b-col v-if="!course_file_allow_add_remove && visibleReports.length > 1" sm="4" md="3" lg="2"
          class="glow-button btn border-warning p-1 m-1 shadow cursor-move rounded-lg"
          @click="!config_programme && selectAllReports()">
          Select all reports
        </b-col>

        <!-- Unselect All: hide if course_file_allow_add_remove is true -->
        <b-col v-if="!course_file_allow_add_remove && selectedReports.length > 0" sm="4" md="3" lg="2"
          class="glow-button btn border-danger p-1 m-1 shadow cursor-move rounded-lg"
          @click="!config_programme && unselectAllReports()">
          Unselect all reports
        </b-col>
        <!-- Available Reports -->
        <b-col sm="4" md="3" lg="2" v-for="report in visibleReports" :key="report.key" v-b-popover.hover.top="report.config === false
          ? 'This file has not been configured. Complete configuration and try downloading again.'
          : ''" :class="{
            'glow-button btn p-1 m-1 shadow cursor-move rounded-lg': true,
            'border-danger': report.config === false
          }" @click="selectReport(report)">
          {{ report.name }}
        </b-col>
      </b-row>

      <br />

      <!-- Selected reports -->
      <b-row v-if="!config_programme">
        <h4>
          Selected reports are listed below. Grab and move to reorder them as required in course file.
        </h4>
      </b-row>
      <br />

      <b-container>
        <b-col v-if="selectedReports.length < 1" sm="8" md="8" lg="8" class="text-danger shadow rounded-lg">
          Please choose reports from above
        </b-col>

        <draggable :list="selectedReports" :disabled="config_programme === true">
          <b-col v-for="(report, index) in selectedReports" :key="report.key"
            class="shadow rounded-lg p-2 my-2 d-flex justify-content-between align-items-center" style="cursor: grab;">
            <div class="d-flex align-items-center">
              <i v-if="!config_programme" class="fas fa-bars mr-2" aria-hidden="true"></i>
              <span class="mr-1">{{ index + 1 }}.</span>
              {{ report.name }}
            </div>
            <i v-if="!config_programme || (course_file_allow_add_remove && report.selected)" role="button"
              class="text-danger fa fa-times-circle-o" aria-hidden="true"
              @click="(config_programme && !report.selected) ? null : deSelectReport(report)"></i>
          </b-col>
        </draggable>
      </b-container>

      <br /><br />

      <!-- Config mode warning -->
      <span v-if="config_programme" class="text-danger">
        <b>
          <span>Course file order has been set by Admin. Some reports with <i class="text-danger fa fa-times-circle-o"
              style="font-size: 18px !important;"></i> may be removed
            or added as per your requirements.</span>
        </b>
      </span>

      <!-- Loading state -->
      <b-row v-if="loadData" class="text-danger"> Please wait.... </b-row>

      <!-- Action buttons -->
      <b-row v-else>
        <b-col sm="2">
          <b-button class="mt-2" variant="danger" @click="$emit('cancel')">Back</b-button>
        </b-col>
        <b-col>
          <b-button class="mt-2" variant="danger" @click="SaveDownloadCourseDiaryReports(true, false)">
            Save & Download Report
          </b-button>
          <b-button class="mt-2 ml-1" variant="primary" @click="SaveDownloadCourseDiaryReports(true, true)">
            Save & View Report
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["courseReport"],
  data() {
    return {
      fetchData: false,
      loadData: false,
      reportOptions: [],
      selectedReports: [],
      save_config: false,
      config_programme: false,
      course_file_allow_add_remove: false,
      course_file_order_option: 1,
    };
  },
  computed: {
    visibleReports() {
      return this.reportOptions.filter(r => !(this.config_programme && !r.selected));
    },
  },
  async created() {
    this.fetchData = true;
    await this.getCourseDiaryReportsDetails();
    this.fetchData = false;
  },
  methods: {
    selectReport(report) {
      if (!report || report.config === false) {
        this.$toast.error(
          "This file has not been configured. Complete configuration and try downloading again.",
          { position: "top", duration: 6000 }
        );
        return;
      }

      this.reportOptions = this.reportOptions.filter(r => r.key !== report.key);

      if (this.course_file_allow_add_remove) {
        let insertIndex = this.selectedReports.findIndex(r => r.originalIndex > report.originalIndex);
        if (insertIndex === -1) insertIndex = this.selectedReports.length;
        this.selectedReports.splice(insertIndex, 0, { ...report, selected: true });
      } else {
        this.selectedReports.push({ ...report, selected: true });
      }

      if (this.config_programme) {
        this.eSelectReport(this.selectedReports.length - 1);
      }
    },

    deSelectReport(report) {
      this.selectedReports = this.selectedReports.filter(r => r.key !== report.key);

      if (this.course_file_allow_add_remove) {
        let insertIndex = this.reportOptions.findIndex(r => r.originalIndex > report.originalIndex);
        if (insertIndex === -1) insertIndex = this.reportOptions.length;
        this.reportOptions.splice(insertIndex, 0, report);
      } else {
        this.reportOptions.push(report);
      }
    },

    async selectAllReports() {
      for (let i = this.reportOptions.length - 1; i >= 0; i--) {
        if (this.reportOptions[i].config !== false) {
          this.selectReport(this.reportOptions[i]);
        }
      }
    },

    unselectAllReports() {
      for (let i = this.selectedReports.length - 1; i >= 0; i--) {
        this.deSelectReport(this.selectedReports[i]);
      }
    },

    eSelectReport(index) {
      console.log("eSelectReport called for", this.selectedReports[index]);
    },

    async SaveDownloadCourseDiaryReports(save_config, viewReport) {
      this.loadData = true;
      const postData = {
        selected_reports: this.selectedReports,
        course_file_order_option: this.course_file_order_option,
        save_config,
      };
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/courses/${this.courseReport.course_id}/coursediaryreport/pdfexport`;

      try {
        const response = await this.$axios.post(url, postData, { responseType: "blob" });
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        const pdfUrl = window.URL.createObjectURL(pdfBlob);

        if (viewReport) {
          const newTab = window.open(pdfUrl, "_blank");
          if (!newTab) this.downloadBlob(response.data);
        } else {
          this.downloadBlob(response.data);
        }
      } catch (error) {
        let errorText = "Failed to Download, please try later";
        if (error.response?.data?.error) {
          errorText = error.response.data.error;
          if (error.response.data.error_reports?.length) {
            errorText =
              "Failed to generate the reports: " +
              error.response.data.error_reports.map(r => r.report).join(", ");
          }
        }
        this.$toast.error(errorText, { position: "top", duration: 6000 });
      } finally {
        this.loadData = false;
      }
    },

    downloadBlob(data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "CourseDiaryList.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    },

    async getCourseDiaryReportsDetails() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/courses/${this.courseReport.course_id}/coursediaryreport/options`;

      try {
        const { data } = await this.$axios.get(url);

        this.course_file_order_option = data.course_file_order_option;

        // base reportOptions with originalIndex
        this.reportOptions = data.course_reports_data.map((r, i) => ({
          ...r,
          originalIndex: i,
        }));

        if (data.program_config_selected_reports?.length > 0) {
          // prepare selectedReports
          this.selectedReports = data.program_config_selected_reports.map((r, i) => ({
            ...r,
            selected: r.selected !== undefined ? r.selected : true,
            originalIndex: r.originalIndex ?? i,
          }));

          // when both old and new order_option == 3 and allow_add_remove is true
          if (
            data.prev_course_file_order_option == 3 &&
            data.course_file_order_option == 3 &&
            data.course_file_allow_add_remove
          ) {
            const prevSelectedKeys = data.selected_reports_keys ?? [];

            const oldSelected = [...this.selectedReports];
            const excludedReports = oldSelected.filter(
              (r) => !prevSelectedKeys.includes(r.key)
            );

            // keep only reports that were previously selected
            this.selectedReports = oldSelected.filter((r) =>
              prevSelectedKeys.includes(r.key)
            );

            // mark excluded reports in reportOptions
            const excludedKeys = excludedReports.map((r) => r.key);

            this.reportOptions = this.reportOptions.map((r, i) => {
              const old = oldSelected.find((o) => o.key === r.key);
              return {
                ...r,
                selected: excludedKeys.includes(r.key) ? true : r.selected,
                originalIndex: old ? old.originalIndex : (r.originalIndex ?? i),
              };
            });
          }

          // remove already selected reports from options
          const selectedKeys = this.selectedReports.map((r) => r.key);
          this.reportOptions = this.reportOptions.filter(
            (r) => !selectedKeys.includes(r.key)
          );
        } else {
          // fallback: pick selected_reports_keys
          const keys = data.selected_reports_keys ?? [];
          keys.forEach((key) => {
            const repo = this.reportOptions.find((r) => r.key === key);
            if (repo && repo.config !== false) {
              this.selectedReports.push({ ...repo, selected: true });
              this.reportOptions = this.reportOptions.filter((r) => r.key !== key);
            }
          });
        }

        this.config_programme = data.config_programme;
        this.course_file_allow_add_remove = data.course_file_allow_add_remove;
      } catch (error) {
        console.error(error);
      } finally {
        this.fetchData = false;
      }
    }
  },
};
</script>

<style>
.glow-button {
  transition: all 0.2s ease-in-out;
}

.glow-button:hover {
  box-shadow: 0 5px 15px rgba(145, 92, 182, 0.4) !important;
}
</style>
